export default (value: string) => {
  const envVar = process.env[value];

  if (!envVar) {
    throw new Error(`${value} could not be found`);
  }

  return envVar;
};
